// @flow
import { makeStyles } from "@material-ui/styles";
export default makeStyles(() => ({
  pointer: { cursor: "pointer" }
}), { index: 1 })